// eslint-disable-next-line no-undef
__webpack_public_path__ = process.env.ASSET_PATH || '/';